import React, { useEffect, useState, useRef } from "react";
import { Modal, Typography, useTheme } from "@mui/material";
import Styles from "../../Subcomponents/userCard/userCard.module.css";
import { Card } from "@mui/material";
import Button from "../../Subcomponents/Button";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../../Components/Icons/Dot";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// import { generateInvoicePdf } from "../../utils/pdfGenerator";
//TimeAgo
import ReactTimeAgo from "react-time-ago";
// import TimeAgo from "javascript-time-ago";
// import en from "javascript-time-ago/locale/en.json";

import { useSelector } from "react-redux";
//Modals
// import TimeLineAndNotes from "../../Modals/TimeLineAndNotes/TimeLineAndNotes";
import AddPreference from "../../Modals/AddPreference/AddPreference";
import { Box, Divider, useMediaQuery } from "@material-ui/core";
import { supabase } from "../../supabaseClient";
import DownloadIcon from "@mui/icons-material/Download";
import VisibilityIcon from "@mui/icons-material/Visibility";
import InvoiceDetailsModal from "./InvoiceDetailsModal";
import ViewInvoiceDetailsModal from "./ViewInvoiceDetailsModal";
import {
  checkIfFVPaymentExists,
  getAgreementDoneLeads,
  getApplicantsByAllotmentPaymentId,
  getCpInvoiceDetails,
  getFVPaymentHistoryByCPpaymentId,
  getLatestCPPaymentStatus,
  getSalesManagerName,
  updateCPaymentStatus,
  updateCPaymentStatusBackToInvoicePending,
} from "../../Services/LeadService";
import ThreeDotsMenu from "../../Subcomponents/ThreeDotsMenu";
import CPInvoiceDetails from "./CPInvoiceDetails";
import PaymentTimeLineAndNotes from "./PaymentTimeLineAndNotes";
import { Snackbar, Alert } from "@mui/material";
import axios from "axios";

// import * as pdfjsLib from "pdfjs-dist";
// pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;
const getChipStyle = (type) => {
  switch (type) {
    case "AOP":
      return {
        color: "#166534",          // deep green text
        backgroundColor: "#DCFCE7" // light green
      };

    case "POP":
      return {
        color: "#1E40AF",          // deep blue text
        backgroundColor: "#DBEAFE" // light blue
      };

    case "Basic":
    default:
      return {
        color: "#7C2D12",          // deep brown/orange text
        backgroundColor: "#FFEDD5" // soft peach
      };
  }
};

const formatPlanDate = (timestamp) => {
  if (!timestamp) return "NA";

  const date = new Date(Number(timestamp));

  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};
function AgreementLeadCard1({
  data,
  actionStyles,
  returnButtonResp,
  onUploadComplete,
}) {
  // TimeAgo.setDefaultLocale(en.locale);
  // TimeAgo.addLocale(en);
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);

  const [style, setStyle] = useState(null);
  const WhatsAppMessage = `Hello Mr.${data?.personName}%0a %0aGreetings from Vilas Javdekar Developers%0a %0aYou have been successfully registered with us through one of our esteemed Channel Partners.We will always be at your service to help you book your Dream Home with VJ. Looking forward to welcome you to our VJ Parivaar soon!Our Official Website is :www.javdekars.com.-Team VJ.`;
  const [dropdownList, setDropdownList] = useState(["Timeline and Notes"]);
  const [timeLineAndNotesModal, setTimeLineAndNotesModal] = useState(false);
  const [addPreferenceModal, setAddPreferenceModal] = useState(false);
  const [copyLeadObj, setCopyLeadObj] = useState(data);
  const [isInvoiceGenerated, setIsInvoiceGenerated] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const fileInputRef = useRef(null);
  const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [invoiceUrl, setInvoiceUrl] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [invoiceData, setInvoiceData] = useState([]);
  // const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("success"); // can be "error"
  const [leadstatus, setLeadStatus] = useState(null);
  const [isGSTPending, setIsGSTPending] = useState(false);
  const [applicants, setApplicants] = useState([]);

  //format date
  function formatDate(dateString) {
    if (!dateString) return "NA";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  const statusDisplayMap = {
    Pending: "Sales App Agreement Done",
    "Partially Payment Done": "Partially Payment Done",
    Reject: "FV Bill Inword Reject",
    InReview: "CP Upload the Invoice",
    InvoicePending: "Pending For Invoice Upload",
    "Invoice Approved": "FV Bill Inword Approved",
    "Payment in Process": "Bill Booked",
    "Part Payment Done": "Part Payment Done",
    "Full Payment Done": "Full Payment Done",
    REJECTED: "FV Bill Inword Reject",
    PendingForInvoice: "Pending For Invoice Upload",
  };

  // Fetch leads data

  const getCpInvoiceData = async () => {
    try {
      console.log("data?.id);", data?.id);
      const resp = await getCpInvoiceDetails(data?.id);
      console.log("Invoice Data:", resp);
      setInvoiceData(resp.data);
    } catch (err) {
      console.error(err);
    }
  };
  const getleadStatus = async () => {
    try {
      console.log("data?.id);", data?.id);
      const resp = await getLatestCPPaymentStatus(data?.id);
      console.log("Invoice Data:", resp);
      setLeadStatus(resp);
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    getCpInvoiceData();
    getleadStatus();
  }, []);

  useEffect(() => {
    const checkGSTPending = async () => {
      try {
        const allInvoices = await getCpInvoiceDetails(data?.id);
        const latestInvoice = allInvoices?.data?.[0];

        if (!latestInvoice) return;

        const FVdata = await getFVPaymentHistoryByCPpaymentId(
          latestInvoice.invoicesId
        );
        const totalAmount = (FVdata || []).reduce(
          (sum, item) => sum + (Number(item.Amount) || 0),
          0
        );

        const basic = Number(data?.Brokerage_Amount_Basic || 0);
        const tds = Number(data?.Brokerage_Amount_TDS || 0);
        const isPending = Math.abs(basic - tds - totalAmount) < 1;

        console.log("🔄 Parent - isGSTPending:", isPending);
        setIsGSTPending(isPending);
      } catch (err) {
        console.error("❌ Error in GST pending calculation:", err);
      }
    };

    checkGSTPending();
  }, [data]);

  useEffect(() => {
    const fetchApplicants = async () => {
      const allotmentPaymentId = data?.allotmentPaymentData?.allotmentPaymentId;
      if (!allotmentPaymentId) return;

      const result = await getApplicantsByAllotmentPaymentId(
        allotmentPaymentId
      );
      setApplicants(result);
    };

    fetchApplicants();
  }, [data]);

  const handleMoreDetailsClick = () => {
    setShowDetails((prev) => !prev);
  };

  const now = new Date();
  const timestamp = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(now.getDate()).padStart(2, "0")}_${String(
    now.getHours()
  ).padStart(2, "0")}-${String(now.getMinutes()).padStart(2, "0")}-${String(
    now.getSeconds()
  ).padStart(2, "0")}`;
  console.log("invoiceData----------------------", invoiceData);
  console.log("invoiceData.data----------------------", invoiceData?.data);
  console.log(
    "invoiceData.data.data[0]----------------------",
    invoiceData?.data?.data[0]
  );

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleViewInvoiceModalOpen = () => setOpenModal(true);
  const handleViewInvoiceModalClose = () => setOpenModal(false);

  // Handle opening the modal and setting the invoice URL
  const handleOpenModal = (url) => {
    setInvoiceUrl(url);
    setIsModalOpen(true);
  };

  // Handle closing the modal
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setInvoiceUrl("");
  };

  //   const handleFileUpload = async (event) => {
  //     // const leadId = copyLeadObj?.leadId;
  //     const file = event.target.files[0];

  //     if (!file || file.type !== "application/pdf") {
  //       console.error("Invalid file type or no file selected");
  //       return;
  //     }

  //     const uploadedFileName = `invoice-${data.id}_${timestamp}.pdf`;
  //     const uploadedPath = `cpinvoices/uploaded_invoice/${uploadedFileName}`;
  //     const generatedPath = `cpinvoices/system_generated_invoice/${uploadedFileName}`;

  //     // try {
  //     //   // Upload user-selected PDF to 'uploaded_invoice' folder
  //     //   await uploadPdfDocumentCP(
  //     //     `uploaded_invoice/invoice-${data.id}_${timestamp}`,
  //     //     file
  //     //   );

  //     //   setUploadedFile(file); // For UI display
  //     //   console.log("✅ Uploaded user invoice to:", uploadedPath);
  //     // } catch (err) {
  //     //   console.error("❌ Uploading user invoice failed:", err.message);
  //     // }

  //     try {
  //   await uploadPdfDocumentCP(
  //     `uploaded_invoice/invoice-${data.id}_${timestamp}`,
  //     file
  //   );

  //   setUploadedFile(file);
  //   console.log("✅ Uploaded user invoice to:", uploadedPath);

  //   // ✅ Show success toast immediately after upload
  //   setToastMessage("User invoice uploaded successfully.");
  //   setShowToast(true);

  // } catch (err) {
  //   console.error("❌ Uploading user invoice failed:", err.message);
  //   setToastMessage("Failed to upload user invoice.");
  //   setShowToast(true);
  // }

  //     // Upload system-generated invoice if exists in localStorage
  //     const storedUrl = localStorage.getItem("generatedInvoiceUrl");
  //     if (storedUrl) {
  //       try {
  //         const response = await fetch(storedUrl);
  //         const blob = await response.blob();
  //         const systemFile = new File([blob], uploadedFileName, {
  //           type: "application/pdf",
  //         });

  //         await uploadPdfDocumentCP(
  //           `system_generated_invoice/invoice-${data.id}_${timestamp}`,
  //           systemFile
  //         );
  //         console.log("✅ Uploaded system-generated invoice to:", generatedPath);
  //       } catch (err) {
  //         console.error(
  //           "❌ Uploading system-generated invoice failed:",
  //           err.message
  //         );
  //       }
  //     }

  //     // Prepare invoice data to send
  //     const invoicePayload = {
  //       CPpaymentId: data?.id, // Replace with your actual payment ID
  //       allotmentPaymentId: data?.allotmentPaymentData?.allotmentPaymentId,
  //       CpId: data?.CpId,
  //       // Cp_Invoice_Url: `${process.env.REACT_APP_SUPABASE_BUCKET_PREFIX}${copyLeadObj.uploadedInvoiceUrl}`,
  //       // System_Invoice_Url: `${process.env.REACT_APP_SUPABASE_BUCKET_PREFIX}${copyLeadObj.systemGeneratedInvoiceUrl}`,
  //       Cp_Invoice_Url: `${process.env.REACT_APP_SUPABASE_BUCKET_PREFIX}/cpinvoices/uploaded_invoice/invoice-${data.id}_${timestamp}.pdf`,
  //       System_Invoice_Url: `${process.env.REACT_APP_SUPABASE_BUCKET_PREFIX}/cpinvoices/system_generated_invoice/invoice-${data.id}_${timestamp}.pdf`,
  //       Cp_Invoice_Number: localStorage.getItem("invoiceNumber"),
  //       Cp_Invoice_Date: localStorage.getItem("invoiceDate"),
  //       FV_Inword_Status: "Pending",
  //       FV_Inword_Number: "",
  //       FV_Bill_Number: "",
  //       Reject_Note: "",
  //       InwardPayload: null,
  //       inwardResponse: null,
  //       FVInvoiceNumber: "",
  //       // FV_UTR: null,
  //       // FVPaymentDate: null,
  //       // FVPaidAmount: null,
  //     };
  //     console.log(invoicePayload);
  //     console.log(
  //       "JSON.stringify(invoicePayload)",
  //       JSON.stringify(invoicePayload)
  //     );

  //     // Post to your backend
  //     try {
  //       updateCPaymentStatus(data?.id)
  //         .then((updatedData) => {
  //           console.log("updatedData", updatedData);
  //           if (updatedData[0].Status === "Pending") {

  //           }
  //         })
  //         .catch((err) => {
  //           console.log(err, "err");
  //         });
  //       // const res = await fetch(`${process.env.REACT_APP_SEND_OTP_MESSAGE_A2P_SERVICE}cpInvoices/addInvoice`, {
  //       // const res = await fetch(`http://localhost:8050/cpInvoices/addInvoice`, {
  //       const res = await fetch(
  //         `https://sandbox.vjerp.com:8050/cpInvoices/addInvoice`,
  //         {
  //           method: "POST",
  //           headers: { "Content-Type": "application/json" },
  //           body: JSON.stringify(invoicePayload),
  //         }
  //       );

  //       const result = await res.json();
  //       if (!res.ok) throw new Error(result.error || "Failed to insert invoice");

  //       console.log("✅ Invoice saved to DB:", result.data);
  //       // ✅ Trigger success popup
  //       // if (onUploadComplete) {
  //       //   onUploadComplete(); // triggers parent state
  //       // }
  //       // setShowSuccessPopup(true); // show popup
  //       // setTimeout(() => {
  //       //   setShowSuccessPopup(false); // hide after 3 seconds
  //       // }, 3000);
  //     } catch (err) {
  //       console.error("❌ Failed to add invoice:", err.message);
  //       return;
  //     }

  //     // Save both URLs into your state
  //     setCopyLeadObj((prev) => ({
  //       ...prev,
  //       uploadedInvoiceUrl: uploadedPath,
  //       systemGeneratedInvoiceUrl: generatedPath,
  //     }));
  //   };

  const handleFileUpload = async (
    event,
    onUploadComplete,
    onInvoiceProcessComplete
  ) => {
    const file = event.target.files[0];

    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/heic",
    ];

    if (!file || !allowedTypes.includes(file.type)) {
      console.error("Invalid file type or no file selected");
      setToastMessage(
        "Please select a valid PDF or image file (jpg, png, jpeg,heic)."
      );
      setToastSeverity("error");
      setShowToast(true);
      return;
    }

    const timestamp = Date.now();
    const extension = file.name.split(".").pop();
    // const uploadedFileName = `invoice-${data.id}_${timestamp}-${file.name}`;
    // const uploadedPath = `cpinvoices/uploaded_invoice/${uploadedFileName}`;
    // const generatedPath = `cpinvoices/system_generated_invoice/${uploadedFileName}`;

    // ✅ generate clean filenames (no user input)
    const uploadedFileName = `invoice-${data.id}_${timestamp}.${extension}`;
    const systemFileName = `invoice-${data.id}_${timestamp}.pdf`;

    const uploadedPath = `cpinvoices/uploaded_invoice/${uploadedFileName}`;
    const generatedPath = `cpinvoices/system_generated_invoice/${systemFileName}`;

    // Upload user-selected invoice
    // try {
    //   await uploadPdfDocumentCP(
    //     `uploaded_invoice/${uploadedFileName}`, // includes full name and extension
    //     file
    //   );

    //   setUploadedFile(file);
    //   console.log("✅ Uploaded user invoice to:", uploadedPath);

    //   // ✅ Show success toast
    //   setToastMessage(" Invoice uploaded successfully.");
    //   setToastSeverity("success");
    //   setShowToast(true);

    //   if (onUploadComplete) onUploadComplete(); // ✅ update button state in modal
    //   if (onInvoiceProcessComplete) onInvoiceProcessComplete(); // ✅ close modal
    // } catch (err) {
    //   console.error("❌ Uploading user invoice failed:", err.message);
    //   setToastMessage("Failed to upload user invoice.");
    //   setToastSeverity("error");
    //   setShowToast(true);
    //   return; // Stop further processing
    // }

    // // Upload system-generated invoice (if any)
    // const storedUrl = localStorage.getItem("generatedInvoiceUrl");
    // if (storedUrl) {
    //   try {
    //     const response = await fetch(storedUrl);
    //     const blob = await response.blob();
    //     const systemFile = new File([blob], uploadedFileName, {
    //       type: "application/pdf",
    //     });

    //     await uploadPdfDocumentCP(
    //       `system_generated_invoice/invoice-${data.id}_${timestamp}.pdf`,
    //       systemFile
    //     );
    //     console.log("✅ Uploaded system-generated invoice to:", generatedPath);
    //   } catch (err) {
    //     console.error(
    //       "❌ Uploading system-generated invoice failed:",
    //       err.message
    //     );
    //     setToastMessage("System invoice upload failed.");
    //     setToastSeverity("warning");
    //     setShowToast(true);
    //   }
    // }

    // Upload user-selected invoice
    try {
      await uploadPdfDocumentCP(`uploaded_invoice/${uploadedFileName}`, file);

      setUploadedFile(file);
      console.log("✅ Uploaded user invoice to:", uploadedPath);

      setToastMessage("Invoice uploaded successfully.");
      setToastSeverity("success");
      setShowToast(true);

      if (onUploadComplete) onUploadComplete();
      if (onInvoiceProcessComplete) onInvoiceProcessComplete();
    } catch (err) {
      console.error("❌ Uploading user invoice failed:", err.message);
      setToastMessage("Failed to upload user invoice.");
      setToastSeverity("error");
      setShowToast(true);
      return;
    }

    // Upload system-generated invoice (if any)
    const storedUrl = localStorage.getItem("generatedInvoiceUrl");
    if (storedUrl) {
      try {
        const response = await fetch(storedUrl);
        const blob = await response.blob();
        const systemFile = new File([blob], systemFileName, {
          type: "application/pdf",
        });

        await uploadPdfDocumentCP(
          `system_generated_invoice/${systemFileName}`,
          systemFile
        );

        console.log("✅ Uploaded system-generated invoice to:", generatedPath);
      } catch (err) {
        console.error(
          "❌ Uploading system-generated invoice failed:",
          err.message
        );
        setToastMessage("System invoice upload failed.");
        setToastSeverity("warning");
        setShowToast(true);
      }
    }
    try {
      ///////////start
      // STEP 1: Update CPPayment status to "Pending"
      // if (data.Status === "Pending For Invoice" || data.Status === "REJECTED") {
      //   updateCPaymentStatus(data.id, data.Status)
      //     .then(async (resp) => {
      //       console.log("✅ Step 1: CPPayment status set to 'Pending'", resp);
      //       if (resp && resp[0] && resp[0].Status === "Pending") {
      //         console.log("CPPayment status updated successfully.");
      //         // STEP 2: Try inserting into CPInvoices via fetch
      //         const invoicePayload = {
      //           CPpaymentId: data?.id,
      //           allotmentPaymentId:
      //             data?.allotmentPaymentData?.allotmentPaymentId,
      //           CpId: data?.CpId,
      //           Cp_Invoice_Url: `${process.env.REACT_APP_SUPABASE_BUCKET_PREFIX}/cpinvoices/uploaded_invoice/invoice-${data.id}_${timestamp}-${file.name}`,
      //           System_Invoice_Url: `${process.env.REACT_APP_SUPABASE_BUCKET_PREFIX}/cpinvoices/system_generated_invoice/invoice-${data.id}_${timestamp}.pdf`,
      //           Cp_Invoice_Number: localStorage.getItem("invoiceNumber"),
      //           Cp_Invoice_Date: localStorage.getItem("invoiceDate"),
      //           FV_Inword_Status: "Pending",
      //           FV_Inword_Number: "",
      //           FV_Bill_Number: "",
      //           Reject_Note: "",
      //           InwardPayload: null,
      //           inwardResponse: null,
      //           FVInvoiceNumber: "",
      //         };
      //         console.log(invoicePayload);

      //         await axios
      //           .post(
      //             `${process.env.REACT_APP_SEND_OTP_MESSAGE_A2P_SERVICE}cpInvoice/addInvoice`,
      //             // "https://sandbox.vjerp.com:8050/cpInvoices/addInvoice",
      //             // "http://localhost:8050/cpInvoices/addInvoice",
      //             invoicePayload,
      //             {
      //               headers: { "Content-Type": "application/json" },
      //             }
      //           )
      //           .then(async (resp) => {
      //             console.log("✅ Invoice added:", resp.data);
      //           })
      //           .catch((err) => {
      //             console.error("❌ Error adding invoice:", err.message);
      //           });
      //       } else {
      //         console.warn(
      //           "⚠️ CPPayment status update failed or not as expected."
      //         );
      //       }
      //     })
      //     .then(async (insertResponse) => {
      //       const isSuccess = insertResponse?.success;
      //       console.log("isSuccess", isSuccess);

      //       if (isSuccess) {
      //         console.log("✅ All steps completed successfully.");

      //         try {
      //           const resp = await getLatestCPPaymentStatus(data?.id);
      //           console.log("🎯 Latest status from DB:", resp);
      //           setLeadStatus(resp); // ✅ Update UI immediately
      //         } catch (err) {
      //           console.error("❌ Failed to fetch updated status:", err);
      //         }

      //         return;
      //       }

      //       console.warn(
      //         "⚠️ Inserting invoice failed — rolling back status..."
      //       );
      //       return updateCPaymentStatusBackToInvoicePending(data.id); // 👈 rollback
      //     })

      //     // .then((finalUpdate) => {
      //     //   if (finalUpdate) {
      //     //     console.log(
      //     //       "✅ Step 3: Updated CPPayment status to 'Pending for invoice'"
      //     //     );
      //     //   }
      //     // })
      //     // .catch((err) => {
      //     //   console.error(
      //     //     "❌ Something went wrong in the overall process:",
      //     //     err
      //     //   );
      //     // });
      // }

      if (data.Status === "Pending For Invoice" || data.Status === "REJECTED") {
        updateCPaymentStatus(data.id, data.Status)
          .then(async (resp) => {
            console.log("✅ Step 1: CPPayment status set to 'Pending'", resp);
            if (resp && resp[0] && resp[0].Status === "Pending") {
              console.log("CPPayment status updated successfully.");
              // STEP 2: Try inserting into CPInvoices via fetch
              const invoicePayload = {
                CPpaymentId: data?.id,
                allotmentPaymentId:
                  data?.allotmentPaymentData?.allotmentPaymentId,
                CpId: data?.CpId,

                // Cp_Invoice_Url: `${process.env.REACT_APP_SUPABASE_BUCKET_PREFIX}/cpinvoices/uploaded_invoice/invoice-${data.id}_${timestamp}-${file.name}`,
                // System_Invoice_Url: `${process.env.REACT_APP_SUPABASE_BUCKET_PREFIX}/cpinvoices/system_generated_invoice/invoice-${data.id}_${timestamp}.pdf`,
                Cp_Invoice_Url: `${process.env.REACT_APP_SUPABASE_BUCKET_PREFIX}/${uploadedPath}`,
                System_Invoice_Url: `${process.env.REACT_APP_SUPABASE_BUCKET_PREFIX}/${generatedPath}`,
                Cp_Invoice_Number: localStorage.getItem("invoiceNumber"),
                Cp_Invoice_Date: localStorage.getItem("invoiceDate"),
                FV_Inword_Status: "Pending",
                FV_Inword_Number: "",
                FV_Bill_Number: "",
                Reject_Note: "",
                InwardPayload: null,
                inwardResponse: null,
                FVInvoiceNumber: "",
                // FV_UTR: null,
                // FVPaymentDate: null,
                // FVPaidAmount: null,
              };
              console.log(invoicePayload);
              console.log(
                "JSON.stringify(invoicePayload)",
                JSON.stringify(invoicePayload)
              );

              try {
                const res = await fetch(
                  `${process.env.REACT_APP_SEND_OTP_MESSAGE_A2P_SERVICE}cpInvoices/addInvoice`,
                  // `https://labour.vjerp.com:8096/cpInvoices/addInvoice`,
                  {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(invoicePayload),
                  }
                );

                const result = await res.json();
                console.log("result---->", result);
                if (!res.ok) {
                  setToastMessage(result?.message);
                  setToastSeverity("error")
                  throw new Error(
                    result?.message || "Failed to insert invoice"
                  );
                }

                console.log("✅ Step 2: Invoice saved to DB:", result.data);

                // Return a success object for the next .then()
                return { success: true };
              } catch (error) {
                console.error("⚠️ Step 2 failed:", error.message);
                return { success: false };
              }
            } else {
              console.warn(
                "⚠️ CPPayment status update failed or not as expected."
              );
            }
          })
          .then(async (insertResponse) => {
            const isSuccess = insertResponse?.success;
            console.log("isSuccess", isSuccess);

            if (isSuccess) {
              console.log("✅ All steps completed successfully.");

              try {
                const resp = await getLatestCPPaymentStatus(data?.id);
                console.log("🎯 Latest status from DB:", resp);
                setLeadStatus(resp); // ✅ Update UI immediately
              } catch (err) {
                console.error("❌ Failed to fetch updated status:", err);
              }

              return;
            }

            console.warn(
              "⚠️ Inserting invoice failed — rolling back status..."
            );
            return updateCPaymentStatusBackToInvoicePending(data.id); // 👈 rollback
          })

          .then((finalUpdate) => {
            if (finalUpdate) {
              console.log(
                "✅ Step 3: Updated CPPayment status to 'Pending for invoice'"
              );
            }
          })
          .catch((err) => {
            console.error(
              "❌ Something went wrong in the overall process:",
              err
            );
          });
      }
      ///////////end

      setToastSeverity("success");
      setShowToast(true);
    } catch (err) {
      console.error("❌ Failed to add invoice:", err.message);
      setToastMessage("Failed to save invoice to database.");
      setToastSeverity("error");
      setShowToast(true);
      return;
    }

    // Save paths in local state
    setCopyLeadObj((prev) => ({
      ...prev,
      uploadedInvoiceUrl: uploadedPath,
      systemGeneratedInvoiceUrl: generatedPath,
    }));
  };

  const handleUploadButtonClick = async () => {
    fileInputRef.current.click();
    try {
      const resp = await getLatestCPPaymentStatus(data?.id);
      console.log("upload", resp);
      setLeadStatus(resp); // ✅ Will update parent and re-render both
    } catch (err) {
      console.error("❌ Failed to fetch updated status:", err);
    }
  };

  const handleDownloadInvoice = async (filePath) => {
    if (!filePath) {
      alert("No invoice found. Please upload one first.");
      return;
    }

    try {
      const cleanPath = filePath.replace(/^cpinvoices\//, ""); // remove bucket prefix
      const { data, error } = await supabase.storage
        .from("cpinvoices")
        .download(cleanPath);

      if (error) throw error;

      const url = URL.createObjectURL(data);
      const link = document.createElement("a");
      link.href = url;
      link.download = cleanPath.split("/").pop(); // filename only
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download failed:", err.message);
      alert("Failed to download invoice. Please try again.");
    }
  };

  // Enable the "Upload Invoice" button once the invoice is generated
  const handleInvoiceGenerationComplete = () => {
    setIsInvoiceGenerated(true); // Mark invoice as generated
  };
  // const handleGenerateInvoice = async () => {
  //   try {
  //     const pdfBytes = await generateInvoicePdf(copyLeadObj);
  //     const blob = new Blob([pdfBytes], { type: "application/pdf" });
  //     const url = URL.createObjectURL(blob);

  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.download = `invoice-VJ${copyLeadObj.leadDisplayId}.pdf`;
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //     URL.revokeObjectURL(url);
  //   } catch (error) {
  //     console.error("Invoice generation failed:", error);
  //     alert("Failed to generate invoice. Please try again.");
  //   }
  // };

  useEffect(() => {
    defineColorSchema();
    return () => { };
  }, []);
  function defineColorSchema() {
    let obj = {};
    if (data?.status === "Allotment Done") {
      obj.chipColor = "#5925DC";
      obj.chipBackgroundColor = "#F4F3FF";
    } else if (data?.status === "Claimed") {
      obj.chipColor = "#F79009";
      obj.chipBackgroundColor = "#FFFAEB";
    } else if (data?.status === "Unit On Hold") {
      obj.chipColor = "#FF4405";
      obj.chipBackgroundColor = "#FFE6D5";
    } else if (data?.status === "Allotment Partial Payment Done") {
      obj.chipColor = "#C01048";
      obj.chipBackgroundColor = "#FFF1F3";
    } else if (data?.status === "Token Payment Pending") {
      obj.chipColor = "#C11574";
      obj.chipBackgroundColor = "#FDF2FA";
    } else if (data?.status === "Token Partial Payment Done") {
      obj.chipColor = "#BC1B06";
      obj.chipBackgroundColor = "#FFF4ED";
    } else if (data?.status === "Token Payment Complete") {
      obj.chipColor = "#3538CD";
      obj.chipBackgroundColor = "#EEF4FF";
    } else if (data?.status === "Site Visit Done") {
      obj.chipColor = "#5925DC";
      obj.chipBackgroundColor = "#F4F3FF";
    } else if (data?.status === "Site Visit Scheduled") {
      obj.chipColor = "#5925DC";
      obj.chipBackgroundColor = "#F4F3FF";
    } else if (data?.status === "Closed") {
      obj.chipColor = "#027A48";
      obj.chipBackgroundColor = "#ECFDF3";
    } else if (data?.status === "Checkpoint One Cleared") {
      obj.chipColor = "#6941C6";
      obj.chipBackgroundColor = "#F4EBFF";
    } else if (data?.status === "Checkpoint Two Cleared") {
      obj.chipColor = "#0E7090";
      obj.chipBackgroundColor = "#ECFDFF";
    } else if (
      data?.status === "Allotment Payment Complete" ||
      data?.status === "Change Unit Requested" ||
      data?.status === "Cancellation Confirmation Pending" ||
      data?.status === "Cancel Unit Done" ||
      data?.status === "Cancel Unit Not Done" ||
      data?.status === "Change Unit Confirmation Rejected" ||
      data?.status === "Change Unit Confirmed" ||
      data?.status === "Change Unit Rejected" ||
      data?.status === "Cancel Unit Requested" ||
      data?.status === "PreSelect Payment Pending" ||
      data?.status === "PreSelect Unit on Hold" ||
      data?.status === "Preselect not confirmed" ||
      data?.status === "PreSelect Partial Payment Done" ||
      data?.status === "PreSelect Confirmation Pending"
    ) {
      obj.chipColor = "#5925DC";
      obj.chipBackgroundColor = "#F4F3FF";
    } else if (data?.status === "Unit on Hold") {
      obj.chipColor = "#C01048";
      obj.chipBackgroundColor = "#FFF1F3";
    } else if (data?.status === "Allotment Payment Pending") {
      obj.chipColor = "#C01048";
      obj.chipBackgroundColor = "#FFF1F3";
    } else if (
      data?.status === "Allotment Partial Payment Done" ||
      data?.status === "Preselect payment not done"
    ) {
      obj.chipColor = "#C01048";
      obj.chipBackgroundColor = "#FFF1F3";
    } else {
      obj.chipColor = "#027A48";
      obj.chipBackgroundColor = "#ECFDF3";
    }

    setStyle(obj);
  }
  function returnButtonRespose(value) {
    console.log(value);
    if (value) {
      returnButtonResp(true);
    }
  }
  console.log("data", data);

  // async function uploadPdfDocumentCP(name, file) {
  //   const [folder, fileName] = name.split("/"); // e.g., "uploaded_invoice/invoice-123"

  //   const { data, error } = await supabase.storage
  //     .from("cpinvoices")
  //     .upload(`${folder}/${fileName}.pdf`, file, {
  //       contentType: "application/pdf",
  //       upsert: true,
  //     });

  //   if (error) throw error;
  //   return data;
  // }

  // function getLeadAlotedProject() {
  //   getAllotedData(copyLeadObj.leadId)
  //     .then((resp) => {
  //       console.log(resp);
  //       resp.data = resp.data.map((each) => ({
  //         ...each,
  //         WhatsAppMessage:
  //           each.status === "Payment Complete" && each.kycFormFilled
  //             ? `Hello Mr.${
  //                 copyLeadObj.leadname
  //               },%0a %0aGreetings from Vilas Javdekar Developers !%0a %0aYour selection ${
  //                 each?.unitId?.projectId?.projectName
  //                   ? each?.unitId?.projectId?.projectName
  //                   : each?.inventoryMergedId?.projectId?.projectName
  //               }.%0a Your Allotment payment status:${
  //                 each.status
  //               }.%0aCustomer Portal link:${
  //                 process.env.REACT_APP_CUSTOMER_PORTAL
  //               }.%0a %0aRegards,Team VJ`
  //             : each.status === "Payment Complete" && !each.kycFormFilled
  //             ? `Hello Mr.${
  //                 copyLeadObj.leadname
  //               },%0a %0aGreetings from Vilas Javdekar Developers !%0a %0aYour selection ${
  //                 each?.unitId?.projectId?.projectName
  //                   ? each?.unitId?.projectId?.projectName
  //                   : each?.inventoryMergedId?.projectId?.projectName
  //               }.%0aYour Allotment payment status:${
  //                 each.status
  //               }.%0aPlease complete your kyc through Customer Portal link:${
  //                 process.env.REACT_APP_CUSTOMER_PORTAL
  //               }.%0a %0aRegards,Team VJ`
  //             : each.status === "Partial Payment Done" && !each.kycFormFilled
  //             ? `Hello Mr.${
  //                 copyLeadObj.leadname
  //               },%0a %0aGreetings from Vilas Javdekar Developers !%0a %0aYour selection ${
  //                 each?.unitId?.projectId?.projectName
  //                   ? each?.unitId?.projectId?.projectName
  //                   : each?.inventoryMergedId?.projectId?.projectName
  //               }.%0aYour Allotment payment status:${
  //                 each.status
  //               }.%0aYou will recieve a confirmation email with more information after the payment has been processed and the booking details form has been completed.${
  //                 process.env.REACT_APP_CUSTOMER_PORTAL
  //               }.%0a %0aRegards,Team VJ`
  //             : each.status === "Partial Payment Done" && each.kycFormFilled
  //             ? `Hello Mr.${
  //                 copyLeadObj.leadname
  //               },%0a %0aGreetings from Vilas Javdekar Developers !%0a %0aYour current Status:${
  //                 copyLeadObj.leadstatus
  //               }.%0aYour Allotment payment status:${
  //                 each.status
  //               }.%0aYour selection ${
  //                 each?.unitId?.projectId?.projectName
  //                   ? each?.unitId?.projectId?.projectName
  //                   : each?.inventoryMergedId?.projectId?.projectName
  //               }.%0aPlease complete your payment through:${
  //                 process.env.REACT_APP_CUSTOMER_PORTAL
  //               }.%0a %0aRegards,Team VJ`
  //             : each.status === "Payment Pending"
  //             ? `Hello Mr.${
  //                 copyLeadObj.leadname
  //               },%0a %0aGreetings from Vilas Javdekar Developers !%0a %0aYour current Status:${
  //                 copyLeadObj.leadstatus
  //               }.%0aYour Allotment payment status:${
  //                 each.status
  //               }.%0aYour selection ${
  //                 each?.unitId?.projectId?.projectName
  //                   ? each?.unitId?.projectId?.projectName
  //                   : each?.inventoryMergedId?.projectId?.projectName
  //               }%0aPlease Confirm your booking by paying through the link below:%0a${
  //                 process.env.REACT_APP_CUSTOMER_PORTAL
  //               }.%0aYou will recieve a confirmation email with more information after the payment has been processed and the booking details form has been completed. %0aRegards,Team VJ`
  //             : `Hello Mr.${
  //                 copyLeadObj.leadname
  //               },%0a %0aGreetings from Vilas Javdekar Developers !%0a %0aYour current Status:${
  //                 copyLeadObj.leadstatus
  //               }.%0aYour Allotment payment status:${
  //                 each.status
  //               }.Your selection ${
  //                 each?.unitId?.projectId?.projectName
  //                   ? each?.unitId?.projectId?.projectName
  //                   : each?.inventoryMergedId?.projectId?.projectName
  //               }%0aPlease Confirm your booking by paying through the link below:%0a:${
  //                 process.env.REACT_APP_CUSTOMER_PORTAL
  //               }.%0aYou will recieve a confirmation email with more information after the payment has been processed and the booking details form has been completed. %0aRegards,Team VJ`,
  //       }));
  //       let allotmentData = resp.data;

  //       setCopyLeadObj((pre) => {
  //         return { ...pre, allotmentData };
  //       });
  //       console.log(copyLeadObj);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }
  // function numberWithCommas(x) {
  //   return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
  // }
  // function toCalculateValueFromPercent(percentage, bsp) {
  //   var numVal1 = Number(bsp);
  //   var numVal2 = Number(percentage) / 100;

  //   var totalValue = numVal1 * numVal2;

  //   return Math.ceil(totalValue);
  // }
  async function uploadPdfDocumentCP(name, file) {
    const [folder, fileName] = name.split("/"); // e.g., "uploaded_invoice/invoice-123.jpg"

    const { data, error } = await supabase.storage
      .from("cpinvoices")
      .upload(`${folder}/${fileName}`, file, {
        contentType: file.type, // dynamically use correct MIME type
        upsert: true,
      });

    if (error) throw error;
    return data;
  }

  console.log("Agreement lead card1", data);
  const [salesManagerName, setSalesManagerName] = useState("");

  useEffect(() => {
    const fetchSalesManagerName = async () => {
      const name = await getSalesManagerName(data?.leadData?.leadId);

      setSalesManagerName(name);
    };

    fetchSalesManagerName();
  }, [data]);



  return (
    <>
      <Card className={Styles.userCard}>
        {isMobile ? (
          <div className={Styles.head}>
            <div className={Styles.nm} style={{ width: "auto" }}>
              <div className={Styles.pref}>
                {data?.personData?.name?.[0] || "A"}
              </div>
              <div className={Styles.title}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div className={Styles.name}>
                    {data?.personData?.name || data?.planName}
                    {/* <div className={Styles.fosId}>
                      {"VJ" +
                        data?.leadData?.leadDisplayId?.replace(
                          data?.leadData?.leadDisplayId?.substring(8, 12),
                          "-" + data?.leadData?.leadDisplayId?.substring(8, 12)
                        )}
                    </div> */}
                    <div className={Styles.fosId}>
                      {(() => {
                        const id =
                          data?.leadData?.leadDisplayId || // Agreement
                          data?.annexureRows?.[0]?.leadDisplayId; // AOP/POP

                        if (!id) return "VJ-NA";

                        return (
                          "VJ" +
                          id.replace(
                            id.substring(8, 12),
                            "-" + id.substring(8, 12)
                          )
                        );
                      })()}
                    </div>
                  </div>
                  {/* {applicants?.length > 0 && (
                    <div
                      style={{
                        fontSize: "1.4rem",
                        color: "#667085",
                        marginTop: "0.4rem",
                      }}
                    >
                      <strong>Agreement Name1:</strong>{" "}
                      {(() => {
                        const applicant = applicants[0]?.applicant;
                        const first = applicant?.firstName || "";
                        const middle = applicant?.middleName
                          ? " " + applicant.middleName
                          : "";
                        const last = applicant?.lastName
                          ? " " + applicant.lastName
                          : "";
                        return `${first}${middle}${last}`.trim();
                      })()}
                    </div>
                  )} */}
                </div>
              </div>
              <div>
                <ThreeDotsMenu
                  list={dropdownList}
                  selectedValue={(e) => {
                    if (e === "Timeline and Notes") {
                      setTimeLineAndNotesModal(true);
                    }
                  }}
                />
              </div>
            </div>

            {/* Time and Dots Section - Keep this as is */}
            <div className={Styles.headerDiv3}>
              <div className={Styles.invoiceStatus}>
                {isGSTPending ? (
                  <LeadStatusChip
                    style={{
                      color: "#1570EF",
                      backgroundColor: "#EFF8FF",
                    }}
                    label="Payment Done with GST Hold"
                    icon={<Dot width="0.5rem" height="0.5rem" />}
                  />
                ) : (
                  <LeadStatusChip
                    style={{
                      color: leadstatus === "REJECTED" ? "#D92D20" : "#1570EF",
                      backgroundColor:
                        leadstatus === "REJECTED" ? "#FEF3F2" : "#EFF8FF",
                      border: `1px solid ${leadstatus === "REJECTED" ? "#FEF3F2" : "#EFF8FF"
                        }`,
                    }}
                    label={
                      leadstatus === "REJECTED"
                        ? "Invoice Rejected"
                        : leadstatus === "APPROVED"
                          ? "Invoice Approved"
                          : leadstatus || ""
                    }
                    icon={<Dot width="0.5rem" height="0.5rem" />}
                  />
                )}
              </div>
              <div className={Styles.headerDiv2}>
                {/* <LeadStatusChip
                  style={{
                    color: style?.chipColor,
                    backgroundColor: style?.chipBackgroundColor,
                  }}
                  label={"Agreement Done"}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                /> */}

                <div>
                  <ReactTimeAgo
                    style={{ fontSize: "1.2rem" }}
                    date={
                      data?.statuschangeddate ||
                      data?.allotmentPaymentData?.last_updated_at ||
                      data?.created_at || // ✅ for AOP/POP
                      Date.now() // ✅ final fallback
                    }
                    locale="en-US"
                  />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className={Styles.head}>
            <div className={Styles.nm} style={{ width: "auto" }}>
              <div className={Styles.pref}>
                {data?.personData?.name?.[0] || "A"}
              </div>
              <div className={Styles.title}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div className={Styles.name}>
                    {data?.personData?.name || data?.planName}
                    {/* <div className={Styles.fosId}>
                      {"VJ" +
                        data?.leadData?.leadDisplayId?.replace(
                          data?.leadData?.leadDisplayId?.substring(8, 12),
                          "-" + data?.leadData?.leadDisplayId?.substring(8, 12)
                        )}
                    </div> */}
                    {/* <div className={Styles.fosId}>
                      {(() => {
                        const id =
                          data?.leadData?.leadDisplayId || // Agreement
                          data?.annexureRows?.[0]?.leadDisplayId; // AOP/POP

                        if (!id) return "VJ-NA";

                        return (
                          "VJ" +
                          id.replace(
                            id.substring(8, 12),
                            "-" + id.substring(8, 12)
                          )
                        );
                      })()}
                    </div> */}
                    {data?.type !== "AOP" && data?.type !== "POP" && (
                      <div className={Styles.fosId}>
                        {(() => {
                          const id =
                            data?.leadData?.leadDisplayId || // Agreement
                            data?.annexureRows?.[0]?.leadDisplayId; // AOP/POP

                          if (!id) return "VJ-NA";

                          return (
                            "VJ" +
                            id.replace(
                              id.substring(8, 12),
                              "-" + id.substring(8, 12)
                            )
                          );
                        })()}
                      </div>
                    )}
                  </div>
                  {/* {applicants?.length > 0 && (
                    <div
                      style={{
                        fontSize: "1.4rem",
                        color: "#667085",
                        marginTop: "0.4rem",
                      }}
                    >
                      <strong>Agreement Name:</strong>{" "}
                      {(() => {
                        const applicant = applicants[0]?.applicant;
                        const first = applicant?.firstName || "";
                        const middle = applicant?.middleName
                          ? " " + applicant.middleName
                          : "";
                        const last = applicant?.lastName
                          ? " " + applicant.lastName
                          : "";
                        return `${first}${middle}${last}`.trim();
                      })()}
                    </div>
                  )} */}
                </div>
              </div>
            </div>

            <div className={Styles.invoiceStatus}>
              {isGSTPending ? (
                <LeadStatusChip
                  style={{
                    color: "#1570EF",
                    backgroundColor: "#EFF8FF",
                  }}
                  label="Payment Done with GST Hold"
                  icon={<Dot width="0.5rem" height="0.5rem" />}
                />
              ) : (
                <LeadStatusChip
                  style={{
                    color: leadstatus === "REJECTED" ? "#D92D20" : "#1570EF",
                    backgroundColor:
                      leadstatus === "REJECTED" ? "#FEF3F2" : "#EFF8FF",
                    border: `1px solid ${leadstatus === "REJECTED" ? "#FEF3F2" : "#EFF8FF"
                      }`,
                  }}
                  label={
                    leadstatus === "REJECTED"
                      ? "Invoice Rejected"
                      : leadstatus === "APPROVED"
                        ? "Invoice Approved"
                        : leadstatus || ""
                  }
                  icon={<Dot width="0.5rem" height="0.5rem" />}
                />


              )}
            </div>
            {/* <LeadStatusChip
              style={{
                color: "#344054",
                backgroundColor: "#a5c3f0",
              }}
              label={data?.BrokerageType || "Basic"}
              icon={<Dot width="0.5rem" height="0.5rem" />}
            /> */}
            <LeadStatusChip
              style={getChipStyle(data?.BrokerageType)}
              label={data?.BrokerageType || "Basic"}
              icon={<Dot width="0.5rem" height="0.5rem" />}
            />

            {/* Time and Dots Section - Keep this as is */}
            <div className={Styles.headerDiv2}>
              {/* <LeadStatusChip
                style={{
                  color: style?.chipColor,
                  backgroundColor: style?.chipBackgroundColor,
                }}
                label={"Agreement Done"}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              /> */}

              {/* ✅ ADD THIS HERE */}

              <div>
                <ReactTimeAgo
                  date={
                    data?.statuschangeddate ||
                    data?.allotmentPaymentData?.last_updated_at ||
                    data?.created_at ||
                    Date.now()
                  }
                />
              </div>
              <div>
                <ThreeDotsMenu
                  list={dropdownList}
                  selectedValue={(e) => {
                    if (e === "Timeline and Notes") {
                      setTimeLineAndNotesModal(true);
                    }
                  }}
                />
              </div>
            </div>
          </div>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            fontSize: "1.4rem",
            color: "#344054",
            lineHeight: "2.2rem",
            flexWrap: "wrap",
            gap: "1.6rem", // increased spacing
          }}
        >
          {/* Left block: Contact + Unit + Agreement Date */}
          <div style={{ flex: "1 1 60%" }}>
            <div>
              {data?.personData
                ? `+${data?.personData?.contactNumber} | ${data?.personData?.email}`
                : ""}
            </div>
            {/* <div style={{ marginTop: "0.4rem" }}>
              <strong>Unit:</strong>{" "}
              {copyLeadObj?.inventoryDataForLead?.unitNo || "NA"} |{" "}
              {copyLeadObj?.wingData?.wingName || "NA"} |{" "}
              {copyLeadObj?.projectData?.projectName || "NA"}
            </div> */}

            <div style={{ marginTop: "0.4rem" }}>
              <strong>Project:</strong>{" "}
              {data?.projectData?.projectName || "NA"}

              {/* ✅ AGREEMENT → same line */}
              {data?.BrokerageType === "Basic" && (
                <>
                  {" | "}
                  {copyLeadObj?.inventoryDataForLead?.unitNo || "NA"} |{" "}
                  {copyLeadObj?.wingData?.wingName || "NA"}
                </>
              )}
            </div>

            {/* ✅ AOP / POP → NEW LINE */}
            {(data?.BrokerageType === "AOP" || data?.BrokerageType === "POP") && (
              <div style={{ marginTop: "0.4rem" }}>
                <strong>Validity:</strong>{" "}
                {data?.BrokerageType === "AOP" && (
                  <>
                 {formatPlanDate(data?.aopStartDate)} to {formatPlanDate(data?.aopEndDate)}
                  </>
                )}
                {data?.BrokerageType === "POP" && (
                  <>
                 {formatPlanDate(data?.popStartDate)} to {formatPlanDate(data?.popEndDate)}
                  </>
                )}
              </div>
            )}
            {/* <div style={{ marginTop: "0.4rem" }}>
              <strong>Agreement Date:</strong>{" "}
              {formatDate(
                copyLeadObj?.AgreementDate || data?.created_at
              )}
            </div> */}

            {data?.BrokerageType === "Basic" && (
              <div style={{ marginTop: "0.4rem" }}>
                <strong>Agreement Date:</strong>{" "}
                {formatDate(
                  copyLeadObj?.AgreementDate || data?.created_at
                )}
              </div>
            )}
          </div>

          {/* Right block: FOS and SM stacked */}
          {/* <div style={{ minWidth: "140px" }}>
            <div>
              <strong>FOS:</strong>{" "}
              {data?.fosData?.name === "-" ? "NA" : data?.fosData?.name}
            </div>
            {data?.status !== "Unclaimed" && (
              <div>
                <strong>VJ SM:</strong> {salesManagerName || ""}
              </div>
            )}
          </div> */}

          {/* ✅ SHOW ONLY FOR AGREEMENT */}
          {data?.BrokerageType === "Basic" && (
            <div style={{ minWidth: "140px" }}>
              <div>
                <strong>FOS:</strong>{" "}
                {data?.fosData?.name === "-" ? "NA" : data?.fosData?.name}
              </div>
              {data?.status !== "Unclaimed" && (
                <div>
                  <strong>VJ SM:</strong> {salesManagerName || ""}
                </div>
              )}
            </div>
          )}
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: isMobile ? "row" : "row",
            justifyContent: "space-between",
            alignItems: isMobile ? "stretch" : "center",
            flexWrap: "wrap",
            marginTop: "2rem",
            gap: "1.6rem",
          }}
        >
          {/* Left side — keep empty or put other content if needed */}
          <button
            onClick={handleMoreDetailsClick}
            style={{
              color: "#1570EF",
              borderRadius: "2.4rem",
              backgroundColor: "#EFF8FF",
              fontSize: "1.6rem",
              lineHeight: "2.4rem",
              border: "1px solid #EFF8FF",
              padding: "0.6rem 1.2rem",
              display: "flex",
              alignItems: "center",
              gap: "0.4rem",
              cursor: "pointer",
              width: "fit-content", // ✅ prevents button from stretching full width
              backgroundClip: "padding-box", // ✅ clips background to border-box
              WebkitTapHighlightColor: "transparent", // ✅ removes tap overlay on mobile
              maxWidth: "100%", // ✅ optional safety for responsiveness
            }}
          >
            {showDetails ? "Hide Details" : "More Details"}
            {showDetails ? (
              <KeyboardArrowUpIcon
                style={{ color: "#1570EF", width: "2.4rem", height: "2.4rem" }}
              />
            ) : (
              <KeyboardArrowDownIcon
                style={{ color: "#1570EF", width: "2.4rem", height: "2.4rem" }}
              />
            )}
          </button>

          {/* Right Side Button Group */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "1.6rem",
              flexWrap: "wrap",
            }}
          >
            {/* Invoice Info Button */}
            <button
              onClick={handleViewInvoiceModalOpen}
              style={{
                backgroundColor: "#1570EF",
                color: "#fff",
                border: "none",
                padding: "0.8rem 1.6rem",
                borderRadius: "4px",
                fontSize: "1.4rem",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "0.6rem",
              }}
            >
              <VisibilityIcon style={{ fontSize: "2rem" }} />
              Invoice Info
            </button>

            {/* Generate Invoice Button */}
            {/* <button
              onClick={() => setInvoiceModalOpen(true)}
              title="Generate Invoice"
              style={{
                backgroundColor: "#1570EF",
                color: "#fff",
                border: "none",
                padding: "0.8rem 1.6rem",
                borderRadius: "4px",
                fontSize: "1.4rem",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "0.6rem",
              }}
            >
              <NoteAddIcon style={{ fontSize: "2rem" }} />
              {!isInvoiceGenerated && "Generate Invoice"}
            </button> */}

            {(data?.Status === "Pending For Invoice" ||
              data?.Status === "REJECTED") && (
                <button
                  onClick={() => setInvoiceModalOpen(true)}
                  title="Generate Invoice"
                  disabled={isInvoiceGenerated}
                  style={{
                    backgroundColor: isInvoiceGenerated ? "#ccc" : "#1570EF",
                    color: "#fff",
                    border: "none",
                    padding: "0.8rem 1.6rem",
                    borderRadius: "4px",
                    fontSize: "1.4rem",
                    cursor: isInvoiceGenerated ? "not-allowed" : "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.6rem",
                    opacity: isInvoiceGenerated ? 0.6 : 1,
                  }}
                >
                  <NoteAddIcon style={{ fontSize: "2rem" }} />
                  {!isInvoiceGenerated && "Generate Invoice"}
                  {isInvoiceGenerated && "Invoice Uploaded"}
                </button>
              )}

            {/* Download Invoice Icon */}
            {/* {copyLeadObj?.uploadedInvoiceUrl && (
              <button
                onClick={() =>
                  handleDownloadInvoice(copyLeadObj.uploadedInvoiceUrl)
                }
                title="Download Uploaded Invoice"
                style={{
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <DownloadIcon
                  style={{ color: "#1570EF", fontSize: "2.4rem" }}
                />
              </button>
            )} */}

            {/* View Invoice Icon */}
            {copyLeadObj?.uploadedInvoiceUrl && (
              <button
                onClick={() =>
                  handleOpenModal(
                    `${process.env.REACT_APP_SUPABASE_BUCKET_PREFIX}${copyLeadObj.uploadedInvoiceUrl}`
                  )
                }
                title="View Uploaded Invoice"
                style={{
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
                
              >
                <VisibilityIcon
                  style={{ color: "#1570EF", fontSize: "2.4rem" }}
                />
              </button>
            )}

            {/* Uploaded File Name */}
            {uploadedFile && (
              <span
                style={{
                  fontSize: "1.2rem",
                  color: "#344054",
                  maxWidth: "160px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {uploadedFile.name.length > 20
                  ? `${uploadedFile.name.slice(0, 17)}...`
                  : uploadedFile.name}
              </span>
            )}
          </div>
        </div>

        {showDetails && (
          <div
            style={{
              marginTop: "2rem",
              backgroundColor: "#F9FAFB",
              padding: "1.6rem",
              borderRadius: "0.8rem",
              display: "flex",
              flexDirection: "column",
              gap: "2rem",
            }}
          >
            {console.log("invoiceData?.data======", invoiceData)}

            {/* {invoiceData?.map((invoice, index) => (
              <CPInvoiceDetails
                key={index}
                invoice={invoice}
                index={index}
                data={data}
              />
            ))} */}

            {invoiceData
              ?.slice()
              .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)) // ⬅️ descending order (latest first)
              .map((invoice, index) => (
                <CPInvoiceDetails
                  key={index}
                  invoice={invoice}
                  index={index}
                  data={data}
                />
              ))}
          </div>
        )}
      </Card>

      {/* Modal to display the Invoice */}
      <Modal open={isModalOpen} onClose={handleCloseModal}>
        <Box sx={modalStyle}>
          <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
            Invoice Details
          </Typography>
          <Box sx={{ width: "100%", height: "500px", overflow: "auto" }}>
            {/* Display the invoice content, e.g., as an iframe */}
            {invoiceUrl.endsWith(".pdf") ? (
              <iframe
                src={invoiceUrl}
                width="100%"
                height="100%"
                frameBorder="0"
                title="Invoice Preview"
              />
            ) : (
              <img
                src={invoiceUrl}
                alt="Uploaded Invoice"
                style={{
                  width: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                }}
              />
            )}
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <button
              onClick={handleCloseModal}
              style={{
                padding: "8px 16px",
                fontSize: "1rem",
                backgroundColor: "#1570EF",
                color: "#fff",
                border: "none",
                cursor: "pointer",
                borderRadius: "5px",
                alignSelf: "flex-end", // Ensures it's aligned to the bottom-right
              }}
            >
              Close
            </button>
          </Box>
        </Box>
      </Modal>

      {timeLineAndNotesModal && (
        <PaymentTimeLineAndNotes
          open={timeLineAndNotesModal}
          handleClose={() => {
            setTimeLineAndNotesModal(false);
          }}
          data={data}
        />
      )}

      <InvoiceDetailsModal
        open={invoiceModalOpen}
        onClose={() => setInvoiceModalOpen(false)}
        leadData={copyLeadObj}
        setIsInvoiceGenerated={setIsInvoiceGenerated}
        handleFileUpload={handleFileUpload}
        handleUploadButtonClick={handleUploadButtonClick}
        fileInputRef={fileInputRef}
        leadStatus={leadstatus}
        setLeadStatus={setLeadStatus}
        data={data}
      />

      <ViewInvoiceDetailsModal
        open={openModal}
        handleClose={handleViewInvoiceModalClose}
        leadData={copyLeadObj}
      />
      <Snackbar
        open={showToast}
        autoHideDuration={3000}
        onClose={() => setShowToast(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{
          "& .MuiPaper-root": {
            minWidth: "400px",
          },
        }}
      >
        <Alert
          onClose={() => setShowToast(false)}
          severity={toastSeverity}
          sx={{
            width: "100%",
            fontSize: "1.4rem",
            padding: "1rem 2rem",
          }}
        >
          {toastMessage}
        </Alert>
      </Snackbar>
    </>
  );
}
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "#fff",
  padding: "2rem",
  borderRadius: "8px",
  width: "90%", // Increased width to 90% for better layout on large screens
  maxWidth: "1000px", // Set to a higher value for wider content
  maxHeight: "80vh", // Ensure modal content doesn't overflow
  boxShadow: "0px 10px 30px rgba(0,0,0,0.2)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between", // Ensures proper spacing
};

const inputStyle = {
  width: "100%",
  padding: "0.8rem",
  fontSize: "1.4rem",
  border: "1px solid #D0D5DD",
  borderRadius: "6px",
  backgroundColor: "#fff",
  color: "#344054",
};
const styles = {
  dialogBox: {
    backgroundColor: "#fff",
    padding: "2rem",
    borderRadius: "8px",
    width: "300px",
    boxShadow: "0 0 20px rgba(0,0,0,0.2)",
  },
  successPopup: {
    position: "fixed",
    bottom: "2rem",
    right: "2rem",
    backgroundColor: "#28a745",
    color: "#fff",
    padding: "1rem 2rem",
    borderRadius: "8px",
    fontSize: "1.4rem",
    boxShadow: "0 0 10px rgba(0,0,0,0.3)",
    zIndex: 10001,
  },
};
export default AgreementLeadCard1;